module.exports = __webpack_public_path__ + "static/kontact-link-bg-cd9e0b23a466ae10a776aa3766bd1aae.png";